export const ROUTE_LOGIN = "UserLogin";
export const ROUTE_DASHBOARD = "dashboard";
export const ROUTE_RESET_PASSWORD = "ResetPassword";
export const ROUTE_SET_PASSWORD = "SetPassword";
export const ROUTE_VERIFY_EMAIL = "VerifyEmail";
export const ROUTE_USERS = "users";
export const ROUTE_USERS_CREATE = "users-create";
export const ROUTE_USERS_DETAILS = "users-details";
export const ROUTE_USERS_EDIT = "users-edit";

export const ROUTE_SETTINGS = "settings";
export const ROUTE_SETTINGS_VERIFICATION = "settings-verification";

export const ROUTE_TRANSFER_METHODS = "transfer-methods";
export const ROUTE_TRANSFER_METHODS_CREATE = "transfer-methods-create";
export const ROUTE_TRANSFER_METHODS_EDIT = "transfer-methods-edit";
export const ROUTE_TRANSFER_METHODS_DETAILS = "transfer-methods-details";

export const ROUTE_PROVIDER_ASSIGNMENTS = "provider-assignments";

export const ROUTE_BALANCE_HISTORY = "balance-history";

export const ROUTE_OPERATIONS_ADMIN = "operations-admin";
export const ROUTE_OPERATIONS_AVAILABLE = "operations-available";
export const ROUTE_OPERATIONS_AVAILABLE_DEPOSITS = "operations-available-deposits";
export const ROUTE_OPERATIONS_AVAILABLE_WITHDRAWALS = "operations-available-withdrawals";
export const ROUTE_OPERATIONS_MINE = "operations-mine";
export const ROUTE_OPERATIONS_MINE_DEPOSITS = "operations-mine-deposits";
export const ROUTE_OPERATIONS_MINE_WITHDRAWALS = "operations-mine-withdrawals";
export const ROUTE_OPERATIONS_DETAIL = "operations-detail";

export const ROUTE_TRANSFERS_DETAIL = "transfers-detail";
